import clsx from 'clsx'

import s from '../styles.module.scss'

import { AirportInfo } from './airport-info'

interface RouteInfoProps {
  departureTime: string
  departureCode: string
  arrivalTime: string
  arrivalCode: string
}

export const RouteInfo = ({
  departureTime,
  departureCode,
  arrivalTime,
  arrivalCode,
}: RouteInfoProps) => (
  <div className={s.routeInfo}>
    <AirportInfo
      time={departureTime}
      code={departureCode}
    />
    <span className={clsx(s.routeSeparator, 'medium-14')}>–</span>
    <AirportInfo
      time={arrivalTime}
      code={arrivalCode}
    />
  </div>
)
